<style scoped>
.progress-loader {
    width: 0;
    opacity: 1;
    position: absolute;
    top: 0;
    height: 3px;
    background: #ffee58;
    box-shadow: 0 0 6px #fdd835, 0 0 3px #fdd835;
    z-index: 500000; /* don't change, should always be the highest element on the screen */
}

.transition {
    transition: all 0.3s ease-in-out;
}

.reset {
    opacity: 0;
}
</style>

<template>
    <!-- loading bar -->
    <div id="progress-loader" class="progress-loader transition" :style="{'width': progressLoaderWidth + '%'}"></div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters(["progressLoaderWidth"]),
    },
};
</script>
